var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-c-video-responsive cf-c-video-responsive--16by9"},[_c('video',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }